import { useRef } from 'react';
import constants from './constants';
import { SignatureType } from './types';
import { Tab } from './modal';
import { SignatureData, SignatureModalBody } from './signature-modal-v2';

export default function useSignatureData(
  type: SignatureType,
  selectedTab: Tab,
) {
  const signatureModalBodyRef = useRef<HTMLElement & SignatureModalBody>(null);

  const getSignatureData = (): SignatureData | null => {
    if (signatureModalBodyRef?.current == null) {
      return null;
    }

    const data = signatureModalBodyRef?.current.getSignatureData();

    if (selectedTab === constants.TAB_SAVED) {
      return data;
    } else {
      return {
        ...data,
        type_code: type,
      } as any;
    }
  };

  return { signatureModalBodyRef, getSignatureData };
}
